<template>
  <b-list-group-item>
    <div class="font-weight-bold text-primary">
      Makbuz
    </div>
    <div>
      <div v-if="dataItem.receipt_no">
        No: {{ dataItem.receipt_no }}
      </div>
      <b-badge :variant="dataItem.is_receipt === '1'? 'light-success' : 'light-danger'">
        {{ dataItem.is_receipt === '1'? 'Makbuz Kesildi' : 'Makbuz Kesilmedi' }}
      </b-badge>
    </div>
  </b-list-group-item>
</template>
<script>
import { BBadge, BListGroupItem } from 'bootstrap-vue'

export default {
  name: 'DonateDate',
  components: {
    BBadge,
    BListGroupItem,
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
  },
}
</script>
